var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.337 36.8213L42.3721 45.579C42.7423 45.7268 43.1375 45.7808 43.5289 45.7371C43.9204 45.6934 44.298 45.5531 44.6344 45.3263C44.9707 45.0996 45.2572 44.7922 45.4729 44.4267C45.6885 44.0611 45.828 43.6466 45.881 43.2135L50.3763 5.45734C50.6499 3.15858 48.5066 1.44384 46.6154 2.44389L3.89656 25.1008C1.7845 26.2208 1.94291 29.6076 4.15097 30.4797L10.0071 32.7944L13.1992 34.0398M28.7997 40.1814L24.0235 49.0511C22.4635 51.2058 19.3218 49.9871 19.3218 47.2297V40.1281C19.3219 38.7879 19.776 37.4969 20.5938 36.5119L29.8845 25.3115",
    stroke: "#168CE3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/Airplane.0033f4c05f2a41db85d3594c61813c6e.svg";
export { ForwardRef as ReactComponent };